var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetails = function SvgDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22253B",
    d: "M3 6a.75.75 0 0 1 .75-.75h16.5a.75.75 0 1 1 0 1.5H3.75A.75.75 0 0 1 3 6m.75 6.75h6.75a.75.75 0 1 0 0-1.5H3.75a.75.75 0 1 0 0 1.5m8.25 4.5H3.75a.75.75 0 1 0 0 1.5H12a.75.75 0 1 0 0-1.5m10.28.22-1.902-1.907a3.75 3.75 0 1 0-1.065 1.065l1.903 1.903a.75.75 0 1 0 1.06-1.062z"
  })));
};
export default SvgDetails;